<template>
  <div class="box-body">
    <div class="row m-b-15">
      <div class="row center-block">
        <div class="col-md-12">
          <div>
            <br />
            <div class="box-body form-center">
              <div class="m-t-10">
                <table class="table table-bordered table-striped dataTable">
                  <thead class="bg-primary">
                  <tr>
                    <td>＃</td>
                    <td>品牌</td>
                    <td>店家</td>
                    <td>活動啟用狀態</td>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(store, sIndex) in storeInfo">
                      <td>
                        {{sIndex + 1}}
                      </td>
                      <td>
                        {{store.brand_name}}
                      </td>
                      <td>{{store.store_name}}</td>
                      <td>
                        <div class="is-enable-store pull-left m-r-5" style="top: 15px" :class="[store.is_enable?'success':'danger']"></div>
                        <!--
                        <select v-model="store.is_enable">
                          <option :value="1">啟用</option>
                          <option :value="0">不啟用</option>
                        </select>
                        -->
                        <multiselect
                                v-model="store.is_enable_obj"
                                :options="enableOption"
                                label="label"
                                :searchable="false"
                                :allow-empty="false"
                                :close-on-select="true"
                                placeholder="啟用"
                                :show-labels="false"
                                :preselect-first="true"
                                style="width: calc(100% - 30px)"
                                class="pull-left"
                                @input="changeSelect(store)"
                        >
                        </multiselect>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.box-body -->
    <div class="box-footer text-center">
      <button class="btn btn-fail" @click="$router.go(-1)">
        取消
      </button>
      <button class="btn btn-success" @click="setData">
        確定
      </button>
    </div>
  </div>
</template>

<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import menuDiscount from './MenuDiscountTemp.vue'
// Require needed datatables modules
import { mapActions, mapGetters } from 'vuex'
export default {
  props: ['isUp'],
  components: {
    'date-time-picker': datetimePicker,
    'menu-discount': menuDiscount
  },
  data () {
    return {
      info: {
        info: {}
      },
      storeInfo: [],
      enableOption: [
        {label: '啟用', value: 1},
        {label: '不啟用', value: 0}
      ]
    }
  },
  created () {
    this.getDiscountInfo()
  },
  methods: {
    ...mapActions(['setMenuStartTime', 'setMenuEndTime']),
    changeSelect (store) {
      store.is_enable = store.is_enable_obj.value
    },
    getDiscountInfo () {
      this.storeInfo = []
      var self = this
      var url = '/discount/' + this.$route.params.activity_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data
          self.info.attend_stores.forEach(function (brand) {
            brand.store_list.forEach(function (store) {
              const newObj = store
              self.$set(newObj, 'brand_name', brand.brand_name)
              self.$set(newObj, 'brand_id', brand.brand_id)
              self.$set(newObj, 'is_enable_obj', self.enableOption.find(function (o) { return store.is_enable === o.value }))
              self.storeInfo.push(newObj)
            })
          })
        }
      })
    },
    setData () {
      var data = {
        enable_store_ids: [],
        disable_store_ids: []
      }
      this.storeInfo.forEach(function (store) {
        if (!store.is_enable) data.disable_store_ids.push(store.store_id)
        else data.enable_store_ids.push(store.store_id)
      })
      this.upDiscount(data)
    },
    upDiscount (data) {
      var self = this
      var url = '/discount/' + this.$route.params.activity_id
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/upDiscountList')
          // self.total = response.data.total
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  }
}
</script>
<style lang="sass">
.coupon-left
  float: left
  width: calc(100% / 3 * 2 + 15px)
  padding-right: 5px
.coupon-right
  float: left
  background: #3c8dbc
  width: calc(100% / 3 - 15px)
  position: absolute
  right: 0
  top: 0
  height: 100%
  border-left: 5px black dashed
  border-radius: 0px 6px 6px 0px
  color: white
  .v-middle
    position: absolute
    top: calc(50% - 28.5px)
    font-size: 40px
    text-align: center
    width: 100%
    left: 0
</style>
<style lang="sass" scoped>
// .ranges
  display: none
.coupon.form-left, .coupon.form-right
  width: 50%
  float: left
.coupon.form-right
  padding: 20px 20px 20px 10px
.coupon.form-left
  padding: 20px 10px 20px 20px
.coupon.form-left.w-100-p
  padding: 20px 20px
.min-item.active, .hour-item.active, .day.checked
  background: #222d32 !important
.w-200
  width: 180px !important
.m-b-15
  margin-bottom: 15px !important
.btn-all-store
  position: absolute
  right: 10px
  z-index: 30
  top: 0px
.input-white
  border: 0px
@media screen and (max-width: 767px)
  .p-sm-10-p
    padding-right: 10px !important
    padding-left: 10px !important
@media screen and (min-width: 768px)
  .p-sm-10-p
    padding-right: calc(20% - 15px) !important
    padding-left: calc(20% + 10px) !important
@media screen and (min-width: 991px)
  .p-sm-10-p
    padding-right: calc(10% - 10px) !important
    padding-left: 10% !important
</style>
<style lang="sass">
  .multiselect__content-wrapper, .multiselect__content-wrapper *
    z-index: 99
  .m-t-0
    margin-top: 0px
  .input-group .form-control
    z-index: auto !important
  textarea
    max-width: 100%
    min-widht: 100%
  .modal-title
    width: calc(100% - 20px)
  @media screen and (max-width: 767px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(100vw - 185px)
  @media screen and (min-width: 768px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(50vw - 190px)
  @media screen and (min-width: 991px)
    .input-group .cov-vue-date .cov-datepicker
      max-width: calc(30vw - 190px)
</style>



// WEBPACK FOOTER //
// DiscountStoreEnableTemp.vue?65d6d3e3